var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.0462L16.0732 9.97312C16.2117 9.83465 16.3857 9.76382 16.5954 9.76062C16.805 9.7574 16.9822 9.82823 17.127 9.97312C17.2719 10.118 17.3444 10.2936 17.3444 10.5C17.3444 10.7064 17.2719 10.882 17.127 11.0269L12.6328 15.5211C12.5392 15.6147 12.4405 15.6808 12.3367 15.7192C12.2328 15.7577 12.1207 15.7769 12.0001 15.7769C11.8796 15.7769 11.7675 15.7577 11.6636 15.7192C11.5598 15.6808 11.4611 15.6147 11.3675 15.5211L6.87325 11.0269C6.73478 10.8885 6.66395 10.7144 6.66075 10.5048C6.65753 10.2952 6.72837 10.118 6.87325 9.97312C7.01812 9.82823 7.19375 9.75579 7.40015 9.75579C7.60655 9.75579 7.78218 9.82823 7.92705 9.97312L12.0001 14.0462Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.2b15e2a81f2f541071094121f8ba9443.svg";
export { ForwardRef as ReactComponent };